import Joi from 'joi';




export const benefitValidationschema = Joi.object({
  bonus_status: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Bonus status must be true or false.",
      "any.required": "Bonus status is required.",
    }),

  ex_gratia: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Ex-gratia must be true or false.",
      "any.required": "Ex-gratia is required.",
    }),

  incentive_application: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Incentive application must be true or false.",
      "any.required": "Incentive application is required.",
    }),

  ot_application: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "OT application must be true or false.",
      "any.required": "OT application is required.",
    }),

  labour_welfare_fund: Joi.boolean()
    .required()
    .messages({
      "boolean.base": "Labour welfare fund must be true or false.",
      "any.required": "Labour welfare fund is required.",
    }),
});


export const schema = Joi.object({
  bonus_status: Joi.boolean().allow("").messages({
    "boolean.base": "Bonus status must be true or false.",
    "any.required": "Bonus status is required.",
  }),

  ex_gratia: Joi.boolean().allow("").messages({
    "boolean.base": "Ex-gratia must be true or false.",
    "any.required": "Ex-gratia is required.",
  }),

  incentive_application: Joi.boolean().allow("").messages({
    "boolean.base": "Incentive application must be true or false.",
    "any.required": "Incentive application is required.",
  }),

  ot_application: Joi.boolean().allow("").messages({
    "boolean.base": "OT application must be true or false.",
    "any.required": "OT application is required.",
  }),

  labour_welfare_fund: Joi.boolean().allow("").messages({
    "boolean.base": "Labour welfare fund must be true or false.",
    "any.required": "Labour welfare fund is required.",
  }),
});


// Employment Setup

export const EmpSetupSchema = Joi.object({
  employmentType: Joi.array()
    .items(Joi.string().valid('full_time', 'part_time', 'contractual',"probationary"))
    .min(1)
    .required()
    .messages({
      'any.required': 'Employment Type is required.',
      'array.base': 'Employment Type must be an array.',
      'array.min': 'Employment Type must contain at least one value.',
      'any.only': 'Employment Type must include only Full Time, Part Time, or Contractual.',
    }),
    provisionDays: Joi.when('employmentType', {
      is: Joi.array().has('probationary'),
      then: Joi.number()
        .min(1) 
        .required()
        .messages({
          'any.required': 'Provision Days are required when Employment Type includes "probationary".',
          'number.base': 'Provision Days must be a valid number.',
          'number.min': 'Provision Days must be greater than 0.',
        }),
      otherwise: Joi.optional(),
    }),
  
  
  isNoticePeriod: Joi.boolean()
    .required()
    .messages({
      'any.required': 'Notice Period selection is required.',
    }),

    noticeDays: Joi.when('isNoticePeriod', {
      is: true,
      then: Joi.number()
        .min(1) 
        .required()
        .messages({
          'any.required': 'Notice Days are required when Notice Period is Yes.',
          'number.base': 'Notice Days must be a valid number.',
          'number.min': 'Notice Days must be at least 1.',
        })
    }),
  prefix: Joi.string()
  .required()
  .messages({
    'any.required': 'Prefix code is required.',
    'string.empty': 'Prefix code cannot be empty.',
  }),
  leave_staging:Joi.boolean().required().messages({
    "any.required":"Weekof is required.",
  }),
  shiftManagement: Joi.boolean().required().messages({
    "any.required": "Shift Management is required.", 
    "boolean.base": "Shift Management must be a boolean value.", 
  }),
  breakTime: Joi.number().required().min(0).max(99).messages({
      'any.required': 'Break Time is required.',
      'number.base': 'Break Time must be a valid number.',
      'number.min': 'Break Time must be at least 0.',
    }),
  workMode: Joi.array()
    .items(Joi.string())
    .min(1)
    .required()
    .messages({
      'any.required': 'Work Mode is required.',
      'array.base': 'Work Mode must be an array.',
      'array.min': 'Work Mode must contain at least one value.',
      'string.base': 'Each Work Mode must be a string.',
    }),
  leave_type: Joi.string()
  .required()
  .messages({
    'any.required': 'Leave Period selection is required.',
    'boolean.base': 'Leave Type must be a true or false value.',
  }),
  loginTime: Joi.string().pattern(/^([01]\d|2[0-3]):([0-5]\d)$/).required(),
  logoutTime: Joi.string().pattern(/^([01]\d|2[0-3]):([0-5]\d)$/).required().custom((value, helpers) => {
    const { loginTime } = helpers.prefs.context;

    if (loginTime && value) {
      const [loginHour, loginMinute] = loginTime.split(':').map(Number);
      const [logoutHour, logoutMinute] = value.split(':').map(Number);

      const loginTotalMinutes = loginHour * 60 + loginMinute;
      const logoutTotalMinutes = logoutHour * 60 + logoutMinute;

      if (logoutTotalMinutes < loginTotalMinutes) {
        return helpers.error('any.custom', 'Login Time must be earlier than Logout Time.');
      }
    }

    return value;
  }).messages({
    'any.required': 'Logout Time is required.',
    'string.base': 'Logout Time must be a valid time string.',
    'any.custom': 'Login Time must be earlier than Logout Time.',
  })

}).unknown(true);
